import {Squares2X2Icon} from "@heroicons/react/24/outline";

/**
 * A React component representing a map cluster marker.
 */
export function ClusterMarker({cluster, hoveredMarkerId}) {
  return (
    <div className="flex items-center bg-white rounded-full transition-all duration-200 shadow-md px-2 py-1 ">
      <Squares2X2Icon className={`text-cs-blue-800 ${hoveredMarkerId === cluster.id ? 'min-w-6' : 'min-w-2'}`}/>

      {/* Expand the marker to show the school name only when this specific marker is hovered */}
      {hoveredMarkerId === cluster.id && (
        <span className="ml-2 whitespace-nowrap text-xs pr-1"> {cluster.name} </span>
      )}
    </div>
  )
}
